import DOMPurify from 'dompurify';

export const mdBold = (text, cls) =>
  DOMPurify.sanitize((text || '').replace(/\*\*(.*?)\*\*/g, `<strong class="${cls}">$1</strong>`), {
    ALLOWED_TAGS: ['strong', 'em', 'br'],
    ALLOWED_ATTR: ['class'],
  });

export const sanitizeHtml = (html) => DOMPurify.sanitize(html || '');
